const guiColors = {
    'motion-primary': '#E30707',
    'motion-primary-transparent': '#E30707e6',
    'motion-tertiary': '#B20000',

    'looks-secondary': '#E30707',
    'looks-transparent': '#ED161659',
    'looks-light-transparent': '#ED161626',
    'looks-secondary-dark': '#940000',

    'extensions-primary': 'hsla(10, 98%, 57%, 1)',
    'extensions-tertiary': 'hsla(10, 98%, 40%, 1)',
    'extensions-transparent': 'hsla(10, 98%, 65%, 0.35)',
    'extensions-light': 'hsla(10, 100%, 81%, 1)',

    'drop-highlight': '#FF8282'
};

const blockColors = {
    checkboxActiveBackground: '#E30707',
    checkboxActiveBorder: '#B20000'
};

export {
    guiColors,
    blockColors
};
